import { render } from "./ArtistCard.vue?vue&type=template&id=62a50552"
import script from "./ArtistCard.vue?vue&type=script&lang=js"
export * from "./ArtistCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArtistCard.vue?vue&type=style&index=0&id=62a50552&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__